import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const About = () => {
    const carouselEvents = {
        autoplay: false,
        loop: true,
        margin: 10,
        nav: true,
        navText: ["<span className='lnr ti-angle-left'></span>", "<span className='lnr ti-angle-right'></span>"],
        dots: true,
        responsive: {
            0: {
                items: 1
            },

            600: {
                items: 2
            },

            1024: {
                items: 3
            },

            1366: {
                items: 3
            },

            1650: {
                items: 4
            }
        }
    };

    return (

        <>

            <div className="banner-header section-padding valign bg-img bg-fixed bg-position-bottom" data-overlay-dark="5" style={{ backgroundImage: `url(img/slider/aboutUs.webp)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 caption text-center">
                            <h1>Our Story</h1>
                            {/* <h4>Travel Agents & Tour Operator</h4> */}
                        </div>
                    </div>
                </div>
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </div>


            <section className="about section-padding bg-white" data-scroll-index="1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

                            <div className="row">

                                {/* Content */}
                                <div className="col-lg-9 col-md-12">

                                    <p>Founded by visionary entrepreneur Mr. Manoj Saluja, <strong>Siddhartha International and Residency Group Hotels</strong>  have emerged as leading hospitality chain in India's Buddhist and Jain circuit. With a deep understanding of the region's rich cultural heritage, our hotels offer serene retreats for travelers seeking spiritual growth, cultural exploration, and memorable experiences.</p>
                                    <p>Driven by a passion for hospitality and a commitment to excellence, Siddhartha International and Residency Group Hotels to cater to the growing demand for authentic and immersive experiences in India's heartland. Our properties in Rajgir, Bodhgaya, Vaishali, and Sravasti provide a unique blend of modern comforts and spiritual significance.</p>
                                    <p>Siddhartha International Tours and Travel Company, Is a recognized and trusted name in the travel industry, approved by the Department of Tourism, Government of India. With over three decades of expertise, we offer personalized travel experiences, exploring India's rich cultural heritage and natural beauty. From spiritual pilgrimages to luxurious retreats, our expert team crafts unforgettable journeys. Discover hidden gems, iconic landmarks, and local traditions with us.</p>

                                    {/* Contact Info */}
                                    <div className="content mt-30">

                                        <div className="cont_about">

                                            <h3>Address</h3>

                                            <address>

                                                802, 8th Floor, New Delhi House, 27,
                                                <br />
                                                Barakhamba Road, New Delhi - 110001
                                                <br />

                                                <strong>Mob. No.</strong>{" "}
                                                <a
                                                    href="tel:+919289300353"
                                                    aria-label="Call Mobile Number"
                                                >
                                                    +91 92893 00353
                                                </a>

                                                <br />

                                                <strong>Tel No.</strong>{" "}
                                                <a
                                                    href="tel:+911143074778"
                                                    aria-label="Call Telephone Number"
                                                >
                                                    +91 11-43074778
                                                </a>
                                                , 23730927

                                                <br />

                                                <strong>Email</strong>{" "}
                                                <a
                                                    href="mailto:siddharthai@hotmail.com"
                                                    aria-label="Send Email"
                                                >
                                                    siddharthai@hotmail.com
                                                </a>

                                            </address>

                                        </div>

                                    </div>

                                    {/* CTA */}
                                    <a
                                        href="https://www.siddharthainternational.com/"
                                        className="butn-dark2"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="Visit Siddhartha International Website"
                                    >
                                        View Details
                                    </a>

                                </div>

                                {/* Image */}
                                <div className="col-lg-3 col-md-12 text-center">

                                    <img
                                        className="img-fluid Manoj-saluja"
                                        src="img/rooms/Manoj-saluja.webp"
                                        alt="Mr. Manoj Saluja"
                                        width="400"
                                        height="500"
                                        loading="lazy"
                                        decoding="async"
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section className="section-padding" data-scroll-index="1">
                <div className="container">
                    {/* <div className="section-title">Video</div> */}
                    <div className="row">
                        <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>
                            <div className='item'>
                                <a href="img/team/about-2026-1.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-1.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-2.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-2.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-3.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-3.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-4.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-4.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-5.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-5.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-6.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-6.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-7.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-7.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-8.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-8.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-9.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-9.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-10.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-10.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-11.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-11.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-12.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-12.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-13.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-13.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-2026-14.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2026-14.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>


                            <div className='item'>
                                <a href="img/team/about-1.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-1.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-a.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-a.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-b.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-b.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-c.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-c.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-d.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-d.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>


                            <div className='item'>
                                <a href="img/team/about-2.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-2.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-3.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-3.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-4.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-4.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-5.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-5.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-6.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-6.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-7.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-7.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-8.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-8.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-9.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-9.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className='item'>
                                <a href="img/team/about-10.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-10.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-11.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-11.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-12.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-12.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-13.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-13.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-14.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-14.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-15.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-15.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-16.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-16.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-17.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-17.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/about-18.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/about-18.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>



                            <div className='item'>
                                <a href="img/team/bus-3.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/bus-3.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/bus-4.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/bus-4.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className='item'>
                                <a href="img/team/bus-5.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img">
                                            <img src="img/team/bus-5.webp" className="img-fluid mx-auto d-block" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>


                        </OwlCarousel>
                    </div>
                </div>
            </section>

            <section className="bg-white">
                <div className="col-md-12">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14007.691430073648!2d77.21265418999756!3d28.63207404449467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd37826e6ee3%3A0x86e193c319a018e2!2sSiddhartha%20International!5e0!3m2!1sen!2sin!4v1751356259203!5m2!1sen!2sin"
                        width="100%"
                        height="350"
                        className="mappie"
                        title="Google Map - Siddhartha International"
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        style={{
                            border: 0,
                        }}
                    ></iframe>

                </div>

            </section>

        </>
    )
};

export default About;